import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M4.37167 7.23917C4.39667 6.99333 4.3025 6.75083 4.11917 6.58583L2.2525 4.33583V4H8.05083L12.5325 13.8292L16.4725 4H22V4.33583L20.4033 5.86667C20.2658 5.97167 20.1975 6.14417 20.2258 6.315V17.5633C20.1975 17.7333 20.2658 17.9058 20.4033 18.0108L21.9625 19.5417V19.8775H14.1192V19.5417L15.735 17.9733C15.8933 17.815 15.8933 17.7683 15.8933 17.5258V8.43417L11.4025 19.8408H10.7958L5.56667 8.43417V16.0792C5.52333 16.4 5.63 16.7242 5.85583 16.9558L7.95667 19.5042V19.8408H2V19.5042L4.10083 16.9558C4.32583 16.7233 4.42583 16.3975 4.37167 16.0792V7.23917Z" />,
  'Medium'
);
